import script from "./diffTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./diffTwo.vue?vue&type=script&setup=true&lang=ts"

import "./diffTwo.vue?vue&type=style&index=0&id=2016d248&lang=less"

const __exports__ = script;

export default __exports__